
(async () => {
    const { Core } = await importModule('Core');

    const CN_ACTIVE = '!active';

    customElements.define('product-buy-with', class extends Core {
        elements = {
            checkbox: '[data-item-checkbox]'
        }

        subscriptions = {
            'cart:update':  '_uncheck'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
        }

        _onChange() {
            this._updateActive();
            this._publishChange();
        }

        _updateActive() {
            this.classList.toggle(CN_ACTIVE, this.checked);
        }

        _uncheck() {
            this.$checkbox.checked = false;
            this.classList.remove(CN_ACTIVE);
            this._publishChange();
        }

        _publishChange() {
            this.publish('buyWith:change', { selected: this.checked })
        }

        get checked() {
            return this.$checkbox.checked
        }
    })
})();